<template>
  <div>
    <h2 class="font-weight-bold mb-4">The identity card data</h2>
    <div class="identification">
      <label for>Your ID:</label>
      <b-form-select required v-model="id" :options="idOptions" @change="isShow">
        <template v-slot:first>
          <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
        </template>
      </b-form-select>
      <div class="id_fields" v-show="show">
        <b-form-group  label="ID Number:" label-for="idnumber">
          <b-form-input id="idnumber" type="text" required placeholder="Type your ID number here"></b-form-input>
        </b-form-group>
        <b-form-group label="First Name as in the document:" label-for="fname">
          <b-form-input id="fname" type="text" required placeholder="First Name"></b-form-input>
        </b-form-group>
        <b-form-group label="Middle Name as in the document:" label-for="mname">
          <b-form-input id="mname" type="text" required placeholder="Middle Name"></b-form-input>
        </b-form-group>
        <b-form-group label="Last Name as in the document:" label-for="lname">
          <b-form-input id="lname" type="text" required placeholder="Last Name"></b-form-input>
        </b-form-group>
        <b-form-group label="Birthdate" label-for="bday">
          <b-form-input id="bday" type="date" required placeholder="Birthdate"></b-form-input>
        </b-form-group>
      </div>
    </div>
    <label for>Your Gender:</label>
    <b-form-select required v-model="gender" :options="genderOptions">
      <template v-slot:first>
        <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
      </template>
    </b-form-select>

    <h2 class="font-weight-bold mb-4">Current address</h2>
    <b-row>
      <b-col cols="12" sm="12" md="4" lg="4">
        <b-form-group label="Postcode:" label-for="zip">
          <b-form-input id="zip" type="number" required placeholder="Enter zip code"></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <label for>Region/ Province:</label>
    <b-form-select required v-model="region" :options="regionOptions">
      <template v-slot:first>
        <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
      </template>
    </b-form-select>
    <label for>Municipality/ City/ Sub municipality</label>
    <b-form-select required v-model="city" :options="cityOptions">
      <template v-slot:first>
        <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
      </template>
    </b-form-select>
    <label for>Barangay</label>
    <b-form-select required v-model="barangay" :options="brgyOptions">
      <template v-slot:first>
        <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
      </template>
    </b-form-select>
    <b-row>
      <b-col cols="12" sm="12" md="6" lg="6">
        <b-form-group label="Street:" label-for="street">
          <b-form-input id="street" type="text" required placeholder="Street"></b-form-input>
        </b-form-group>
      </b-col>
      <b-col cols="12" sm="12" md="3" lg="3">
        <b-form-group label="House:" label-for="house">
          <b-form-input id="house" type="text" required placeholder="House"></b-form-input>
        </b-form-group>
      </b-col>
      <b-col cols="12" sm="12" md="3" lg="3">
        <b-form-group label="Apartment:" label-for="aprt">
          <b-form-input id="aprt" type="text" required placeholder="Apartment"></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <label for>Loan Purposes</label>
    <b-form-select required v-model="loan" :options="loanOptions">
      <template v-slot:first>
        <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
      </template>
    </b-form-select>
    <div class="d-flex justify-content-end mb-4 next">
      <button @click.prevent="$router.push('/registration/step-3')" type="submit">Next Step</button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      id: null,
      idOptions: [
        { value: "a", text: "Social Security System (SSS)" },
        { value: "b", text: "Multipurpose ID" },
        { value: "c", text: "Drivers License" },
        { value: "c", text: "Passport ID" }
      ],
      gender: null,
      genderOptions: [
        { value: "a", text: "Male" },
        { value: "b", text: "Female" }
      ],
      region: null,
      regionOptions: [
        { value: "NORTE", text: "ILOCOS NORTE" },
        { value: "SUR", text: "ILOCOS SUR" },
        { value: "UNION", text: "LA UNION" },
        { value: "PANGASINAN", text: "PANGASINAN" },
        { value: "BATANES", text: "BATANES" },
        { value: "CAGAYAN", text: "CAGAYAN" },
        { value: "ISABELA", text: "ISABELA" },
        { value: "VIZCAYA", text: "NUEVA VIZCAYA" },
        { value: "QUIRINO", text: "QUIRINO" },
        { value: "BATAAN", text: "BATAAN" },
        { value: "BULACAN", text: "BULACAN" },
        { value: "ECIJA", text: "NUEVA ECIJA" },
        { value: "PAMPANGA", text: "PAMPANGA" },
        { value: "TARLAC", text: "TARLAC" },
        { value: "ZAMBALES", text: "ZAMBALES" },
        { value: "AURORA", text: "AURORA" },
        { value: "BATANGAS", text: "BATANGAS" },
        { value: "CAVITE", text: "CAVITE" },
        { value: "LAGUNA", text: "LAGUNA" },
        { value: "QUEZON", text: "QUEZON" },
        { value: "RIZAL", text: "RIZAL" },
        { value: "MARINDUQUE", text: "MARINDUQUE" },
        { value: "MINDORO", text: "OCCIDENTAL MINDORO" },
        { value: "MINDORO", text: "ORIENTAL MINDORO" },
        { value: "PALAWAN", text: "PALAWAN" },
        { value: "ROMBLON", text: "ROMBLON" },
        { value: "ALBAY", text: "ALBAY" },
        { value: "NORTE", text: "CAMARINES NORTE" },
        { value: "SUR", text: "CAMARINES SUR" },
        { value: "CATANDUANES", text: "CATANDUANES" },
        { value: "MASBATE", text: "MASBATE" },
        { value: "SORSOGON", text: "SORSOGON" },
        { value: "AKLAN", text: "AKLAN" },
        { value: "ANTIQUE", text: "ANTIQUE" },
        { value: "CAPIZ", text: "CAPIZ" },
        { value: "ILOILO", text: "ILOILO" },
        { value: "OCCIDENTAL", text: "NEGROS OCCIDENTAL" },
        { value: "GUIMARAS", text: "GUIMARAS" },
        { value: "BOHOL", text: "BOHOL" },
        { value: "CEBU", text: "CEBU" },
        { value: "ORIENTAL", text: "NEGROS ORIENTAL" },
        { value: "SIQUIJOR", text: "SIQUIJOR" },
        { value: "SAMAR", text: "EASTERN SAMAR" },
        { value: "LEYTE", text: "LEYTE" },
        { value: "SAMAR", text: "NORTHERN SAMAR" },
        { value: ")", text: "SAMAR (WESTERN SAMAR)" },
        { value: "LEYTE", text: "SOUTHERN LEYTE" },
        { value: "BILIRAN", text: "BILIRAN" },
        { value: "NORTE", text: "ZAMBOANGA DEL NORTE" },
        { value: "SUR", text: "ZAMBOANGA DEL SUR" },
        { value: "SIBUGAY", text: "ZAMBOANGA SIBUGAY" },
        { value: "BUKIDNON", text: "BUKIDNON" },
        { value: "CAMIGUIN", text: "CAMIGUIN" },
        { value: "NORTE", text: "LANAO DEL NORTE" },
        { value: "OCCIDENTAL", text: "MISAMIS OCCIDENTAL" },
        { value: "ORIENTAL", text: "MISAMIS ORIENTAL" },
        { value: "NORTE", text: "DAVAO DEL NORTE" },
        { value: "SUR", text: "DAVAO DEL SUR" },
        { value: "ORIENTAL", text: "DAVAO ORIENTAL" },
        { value: "VALLEY", text: "COMPOSTELA VALLEY" },
        { value: "OCCIDENTAL", text: "DAVAO OCCIDENTAL" },
        { value: "COTABATO", text: "COTABATO (NORTH COTABATO)" },
        { value: "COTABATO", text: "SOUTH COTABATO" },
        { value: "KUDARAT", text: "SULTAN KUDARAT" },
        { value: "SARANGANI", text: "SARANGANI" },
        { value: "ABRA", text: "ABRA" },
        { value: "BENGUET", text: "BENGUET" },
        { value: "IFUGAO", text: "IFUGAO" },
        { value: "KALINGA", text: "KALINGA" },
        { value: "PROVINCE", text: "MOUNTAIN PROVINCE" },
        { value: "APAYAO", text: "APAYAO" },
        { value: "BASILAN", text: "BASILAN" },
        { value: "SUR", text: "LANAO DEL SUR" },
        { value: "MAGUINDANAO", text: "MAGUINDANAO" },
        { value: "SULU", text: "SULU" },
        { value: "TAWI", text: "TAWI-TAWI" },
        { value: "NORTE", text: "AGUSAN DEL NORTE" },
        { value: "SUR", text: "AGUSAN DEL SUR" },
        { value: "NORTE", text: "SURIGAO DEL NORTE" },
        { value: "SUR", text: "SURIGAO DEL SUR" },
        { value: "ISLANDS", text: "DINAGAT ISLANDS" }
      ],
      city: null,
      cityOptions: [
        { value: "a", text: "Place Sample 1" },
        { value: "b", text: "Place Sample 2" },
        { value: "c", text: "Place Sample 3" },
        { value: "d", text: "Place Sample 4" },
        { value: "e", text: "Place Sample 5" }
      ],
      barangay: null,
      brgyOptions: [
        { value: "a", text: "Place Sample 1" },
        { value: "b", text: "Place Sample 2" },
        { value: "c", text: "Place Sample 3" },
        { value: "d", text: "Place Sample 4" },
        { value: "e", text: "Place Sample 5" }
      ],
      loan: null,
      loanOptions: [
        { value: "a", text: "Bills payment" },
        { value: "a", text: "Medication" },
        { value: "a", text: "Travel Local" },
        { value: "a", text: "Daily allowance" },
        { value: "a", text: "Additional business capital" },
        { value: "a", text: "Education" },
        { value: "a", text: "Home remodeling" },
        { value: "a", text: "Funeral expenses" },
        { value: "a", text: "Rent expense" },
        { value: "a", text: "Appliances / Electronic Gadget" },
        { value: "a", text: "Vehicle Purchase" },
        { value: "a", text: "Wedding" },
        { value: "a", text: "Emergency Fund" },
        { value: "a", text: "Birthday" },
        { value: "a", text: "Revolving fund" },
        { value: "a", text: "Travel abroad" },
        { value: "a", text: "Work abroad" },
        { value: "a", text: "Client's hospitalization" },
        { value: "a", text: "House relocation" },
        { value: "a", text: "Other" }
      ]
    };
  },
  methods: {
      isShow() {
          this.show = true;
      }
  }
};
</script>

<style lang="scss" scoped>
.identification {
  padding: 20px;
  margin-bottom: 20px;
  border-radius: 6px;
  background: $base-bgcolor-lightblue;
  border: 1px solid #ddecfd;
}
</style>